// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  width: 40em;
  height: 60em;
  background: linear-gradient(#f3f3f3, #f3f3f3) padding-box, linear-gradient(145deg, transparent 35%, #88888a, #ffc917) border-box;
  border: 2px solid transparent;
  padding: 32px 24px;
  font-size: 14px;
  font-family: inherit;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  border-radius: 16px;
  overflow-y: scroll;
  font-family: "Varela Round";
}
.form-container_header {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  color: #050505;
  gap: 1em;
  height: 20em;
}
.form-container_header_artist-img {
  width: 10em;
  height: 10em;
  overflow: hidden;
}
.form-container > h2, .form-container h4 {
  color: #050505;
  margin: 0;
}

.artist_x {
  color: #f00000;
  border-radius: 30px;
  font-size: 2em;
  width: 1.5em;
  height: 1.5em;
  cursor: pointer;
}

input, select, textarea {
  color: #050505;
}

.form-container button:active {
  scale: 0.95;
}

.form-container .form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-container .form-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.form-container .form-group label {
  display: block;
  margin-bottom: 5px;
  color: #050505;
  font-weight: 600;
  font-size: 12px;
}

.form-container .form-group input {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  font-family: inherit;
  background-color: rgba(0, 140, 255, 0.062);
  border: 1px solid #414141;
}

.form-container .form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  resize: none;
  height: 96px;
  border: 1px solid #414141;
  background-color: transparent;
  font-family: inherit;
}

.form-container .form-group input::placeholder {
  opacity: 0.5;
}

.form-container .form-group input:focus {
  outline: none;
  border-color: #ffc917;
}

.form-container .form-group textarea:focus {
  outline: none;
  border-color: #ffc917;
}

.form-container .form-submit-btn {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  align-self: flex-start;
  font-family: inherit;
  color: #ffc917;
  font-weight: 600;
  width: 100%;
  background: #313131;
  border: 1px solid #414141;
  padding: 12px 16px;
  font-size: inherit;
  gap: 8px;
  margin-top: 8px;
  cursor: pointer;
  border-radius: 6px;
}

.form-container .form-submit-btn:hover {
  background-color: #ffc917;
  color: #050505;
  border-color: #fff;
}

.modal {
  background-color: rgb(255, 255, 255);
  border-radius: 1em;
  box-shadow: 0px 100px 48px -60px rgba(0, 0, 0, 0.1);
  color: rgb(15, 14, 14);
  overflow: hidden;
  position: relative;
  transition: background-color 0.3s, color 0.3s;
}

.content > *,
.modal > * {
  padding: 0.875em;
}

.title {
  font-size: 1.25em;
  font-weight: 600;
  line-height: 1.2;
  display: flex;
  justify-content: center;
}

.message {
  line-height: 1.2;
  text-align: center;
}

.actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.upload-btn {
  background-color: transparent;
  border: 0.125rem dashed hsla(223, 10%, 50%, 0.4);
  flex: 1 1;
  padding: 0.375rem 2rem;
}

.upload-btn:hover {
  background-color: hsla(223, 10%, 60%, 0.2);
}

.close {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(226, 94, 54);
  height: 30px;
  width: 30px;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}

.result {
  margin-top: 4px;
  background-color: rgba(0, 140, 255, 0.062);
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 1em;
  padding: 0 2em;
}

.file-uploaded {
  font-weight: 300;
}

.file-uploaded::before {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(26, 7, 1, 0.212);
  height: 30px;
  width: 30px;
  border-radius: 50%;
  right: 10px;
  top: 10px;
  color: rgb(255, 255, 255);
  font-weight: bold;
  cursor: pointer;
}

.file-uploaded:hover::before {
  background-color: rgba(233, 40, 6, 0.664);
}

@media (min-width: 390px) {
  .booking-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .booking-form .form-container {
    width: 30em;
    height: 60em;
  }
}
@media (min-width: 1024px) {
  .booking-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .booking-form .form-container {
    width: 40em;
    height: 60em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/booking-form/styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAKA;EACE,WAAA;EACA,YAAA;EACA,gIAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cCxBQ;EDyBR,QAAA;EACA,YAAA;AALJ;AAOI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AALN;AASE;EACE,cCpCQ;EDqCR,SAAA;AAPJ;;AAWA;EACE,cC5CQ;ED6CR,mBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AARF;;AAWA;EACI,cCnDQ;AD2CZ;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARF;;AAWA;EACE,cAAA;EACA,kBAAA;EACA,cCzEU;ED0EV,gBAAA;EACA,eAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0CAAA;EACA,yBAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,oBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,aAAA;EACA,qBAAA;AARF;;AAWA;EACE,aAAA;EACA,qBAAA;AARF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cCzHS;ED0HT,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AARF;;AAWA;EACE,yBCvIS;EDwIT,cCrIU;EDsIV,kBAAA;AARF;;AAWA;EACE,oCAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,6CAAA;AATF;;AAYA;;EAEE,gBAAA;AATF;;AAYA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AATF;;AAYA;EACE,gBAAA;EACA,kBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AATF;;AAYA;EACE,6BAAA;EACA,gDAAA;EACA,SAAA;EACA,sBAAA;AATF;;AAYA;EACE,0CAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AATF;;AAYA;EACE,eAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAVF;;AAaA;EACE,yCAAA;AAVF;;AEzNE;EFuOA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EAVF;EAYE;IACE,WAAA;IACA,YAAA;EAVJ;AACF;AEzNE;EFwOA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EAZF;EAcE;IACE,WAAA;IACA,YAAA;EAZJ;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.booking-form {\n}\n\n.form-container {\n  width: 40em;\n  height: 60em;\n  background: linear-gradient(#f3f3f3, #f3f3f3) padding-box,\n    linear-gradient(145deg, transparent 35%, #88888a, #ffc917) border-box;\n  border: 2px solid transparent;\n  padding: 32px 24px;\n  font-size: 14px;\n  font-family: inherit;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-sizing: border-box;\n  border-radius: 16px;\n  overflow-y: scroll;\n  font-family: \"Varela Round\";\n\n  &_header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    color: $bdt-black;\n    gap: 1em;\n    height: 20em;\n\n    &_artist-img {\n      width: 10em;\n      height: 10em;\n      overflow: hidden;\n    }\n  }\n\n  & > h2, h4 {\n    color: $bdt-black;\n    margin: 0;\n  }\n}\n\n.artist_x {\n  color: $bdt-red;\n  border-radius: 30px;\n  font-size: 2em;\n  width: 1.5em;\n  height: 1.5em;\n  cursor: pointer;\n}\n\ninput, select, textarea{\n    color: $bdt-black;\n}\n\n.form-container button:active {\n  scale: 0.95;\n}\n\n.form-container .form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-container .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.form-container .form-group label {\n  display: block;\n  margin-bottom: 5px;\n  color: $bdt-black;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.form-container .form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-family: inherit;\n  background-color: rgba(0, 140, 255, 0.062);;\n  border: 1px solid #414141;\n}\n\n.form-container .form-group textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 8px;\n  resize: none;\n  height: 96px;\n  border: 1px solid #414141;\n  background-color: transparent;\n  font-family: inherit;\n}\n\n.form-container .form-group input::placeholder {\n  opacity: 0.5;\n}\n\n.form-container .form-group input:focus {\n  outline: none;\n  border-color: #ffc917;\n}\n\n.form-container .form-group textarea:focus {\n  outline: none;\n  border-color: #ffc917;\n}\n\n.form-container .form-submit-btn {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  align-self: flex-start;\n  font-family: inherit;\n  color: $bdt-gold;\n  font-weight: 600;\n  width: 100%;\n  background: #313131;\n  border: 1px solid #414141;\n  padding: 12px 16px;\n  font-size: inherit;\n  gap: 8px;\n  margin-top: 8px;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.form-container .form-submit-btn:hover {\n  background-color: $bdt-gold;\n  color: $bdt-black;\n  border-color: #fff;\n}\n\n.modal {\n  background-color: rgb(255, 255, 255);\n  border-radius: 1em;\n  box-shadow: 0px 100px 48px -60px rgba(0, 0, 0, 0.1);\n  color: rgb(15, 14, 14);\n\n  overflow: hidden;\n  position: relative;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.content > *,\n.modal > * {\n  padding: 0.875em;\n}\n\n.title {\n  font-size: 1.25em;\n  font-weight: 600;\n  line-height: 1.2;\n  display: flex;\n  justify-content: center;\n}\n\n.message {\n  line-height: 1.2;\n  text-align: center;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.upload-btn {\n  background-color: transparent;\n  border: 0.125rem dashed hsla(223, 10%, 50%, 0.4);\n  flex: 1;\n  padding: 0.375rem 2rem;\n}\n\n.upload-btn:hover {\n  background-color: hsla(223, 10%, 60%, 0.2);\n}\n\n.close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgb(226, 94, 54);\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.result {\n  margin-top: 4px;\n  background-color: rgba(0, 140, 255, 0.062);\n  display: flex;\n  align-items: center;\n  position: relative;\n  border-radius: 1em;\n  padding: 0 2em;\n}\n\n.file-uploaded {\n  font-weight: 300;\n}\n\n.file-uploaded::before {\n  position: absolute;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(26, 7, 1, 0.212);\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  right: 10px;\n  top: 10px;\n  color: rgb(255, 255, 255);\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.file-uploaded:hover::before {\n  background-color: rgba(233, 40, 6, 0.664);\n}\n\n@include screen-sm {\n  .booking-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    & .form-container {\n      width: 30em;\n      height: 60em;\n    }\n  }\n}\n\n@include screen-lg {\n  .booking-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    & .form-container {\n      width: 40em;\n      height: 60em;\n    }\n  }\n}\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
